'use client';

import { useSuspenseQuery } from '@tanstack/react-query';
import { useParams } from 'next/navigation';

import { MyRobotManager, MyRobotUrls } from 'lib/api/myRobot';

import { MyRobotsPrimaryInformationResponseDTO } from 'types/models';

/**
 * This schould not be used anywhere else than loading the robot data as than the rest will have the complete validation (including permission chekc) automaticly
 * @param protect weather that should throw an error if no robot id is found
 */
export function useRobotIdParam(protect = true) {
  const params = useParams<{ robotId: string }>();
  // todo - that suddenly is null, why?
  const robotId = params!.robotId;
  if (!robotId && protect) throw new Error('No robot id in params - maybe used outside route?');
  return { robotId: +robotId };
}

export function useMyRobotPrimaryInformation<TData = MyRobotsPrimaryInformationResponseDTO>(
  select?: (data: MyRobotsPrimaryInformationResponseDTO) => TData,
) {
  // this is the main hook so we have to use id from param
  const { robotId } = useRobotIdParam();

  return useSuspenseQuery({
    queryKey: [MyRobotUrls.GetMyRobotPrimaryInformation.url(robotId)],
    queryFn: () => MyRobotManager.GetMyRobotPrimaryInformation(robotId),
    select,
  });
}
